export const defaultState = {
  pagination: { number: 1, size: 1000 },
  sorting: ["name"],
  search: "",
};

export const MAX_CERTIFICATES = 100;
export const MAX_BADGES = 64;
